import React from "react";

const FlashNewsGrid = ({ data, onEdit, onDelete, onCreate }) => {
  return (
    <section className="content container-fluid mt-4">
      <div className="row">
        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
          <div className="box box-primary">
            <div className="box-header with-border d-flex justify-content-between align-items-center">
              <h3>Flash News List</h3>
              <button className="btn btn-success" onClick={onCreate}>
                + Create
              </button>
            </div>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>#</th>
                  <th>News</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data.length === 0 ? (
                  <tr>
                    <td colSpan="3" className="text-center">
                      No flash news available.
                    </td>
                  </tr>
                ) : (
                  data.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{item}</td>
                      <td>
                        <button
                          className="btn btn-sm btn-info me-2"
                          onClick={() => onEdit(index)}
                        >
                          Edit
                        </button>
                        <button
                          className="btn btn-sm btn-danger"
                          onClick={() => onDelete(index)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlashNewsGrid;
